import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

/**
 * Redirects to `to` whenever the store's `isAuthenticated` flag is (or
 * becomes) true — i.e. reactively after a successful sign-in, or immediately
 * on mount if `persist` has already rehydrated an authenticated session from
 * localStorage.
 *
 * Pass `to` explicitly on pages that support deep-linking via a `?redirect=`
 * query param (e.g. LoginPage, RegisterPage). Pages that always redirect to
 * the same destination (e.g. ForgotPasswordPage) can omit it and rely on the
 * default.
 */
export function useRedirectIfAuthenticated(to = '/dashboard') {
  const { isAuthenticated } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate(to, { replace: true });
    }
  }, [isAuthenticated, navigate, to]);
}
